export enum EnumCurrency {
  EURO = "EUR",
  US_DOLLAR = "USD",
  VOUCHER_CREDIT = "VOC",
  VX_COIN = "VXC",
}
